import { useEffect } from 'react';
import { useEffectEventPatch } from './useEffectEvent';
export function useEvent(ref, event, // eslint-disable-next-line @typescript-eslint/no-explicit-any
handler, options) {
    const handleEvent = useEffectEventPatch(handler);
    const isDisabled = handler == null;
    useEffect(()=>{
        if (isDisabled) {
            return;
        }
        const element = ref.current;
        element === null || element === void 0 ? void 0 : element.addEventListener(event, handleEvent, options);
        return ()=>{
            element === null || element === void 0 ? void 0 : element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}

//# sourceMappingURL=useEvent.js.map